import { ISplMessages } from './index';

export class ISplValidation {
    validationStatus: string;
    validationMessages: ISplMessages;
}
